import { type StoreActionApi } from 'react-sweet-state';

import {
	type ExtraErrorAttributes,
	type InnerContainerProps,
	type State,
} from '../common/utils/types';

export const reporterAction =
	({
		id,
		error,
		attributes,
		teamName,
	}: {
		attributes?: ExtraErrorAttributes;
		error: unknown;
		id: string;
		teamName?: string;
	}) =>
	({}: StoreActionApi<State>, { reporter }: InnerContainerProps): void => {
		if (reporter) {
			reporter({ id, error, attributes, teamName });
			return;
		}
	};
